<template>
    
    <!-- <div style="min-height:250px"> -->
      
        <v-container style="max-width:100%;">
             <v-row   style=""      
            >
            <v-col cols = "12" md = "1" sm="12">
                <v-btn class="primary"  :disabled= "disabled" @click="removeMe"><v-icon>mdi-delete</v-icon></v-btn>
            </v-col>
            <v-col cols = "12" md = "2" sm="12">
                    <v-text-field
                    :disabled= "disabled"
                    label="Quantidade de fileiras"
                    hide-details="auto"
                    v-model.number = "mounting.quantity"
                    @change="update"
                  ></v-text-field>
            </v-col>
            <v-col cols = "12" md = "2" sm="12">
                    <v-select class="mt-5"
                     :disabled= "disabled"
                        v-model="mounting.orientation"
                           @change="update"
                        :items="orientationItems"
                        label="Orientação"
                        item-text="text"
                        item-value="value"
                        dense
                      >
                  </v-select>
            </v-col>
  

            <v-col cols = "12" md = "4" sm="12">
                    <v-select class="mt-5"
                     :disabled= "disabled"
                        v-model="mounting.structureId"
                        @change="update"
                        :items="structures"
                        label="Tipo"
                        item-text="structureType"
                        item-value = "id"
                        dense
                      >
                  </v-select>
            </v-col>
            <v-col cols = "12" md = "2" sm="12" >
                    <v-text-field
                     :disabled= "disabled"
                    label="Quantidade de módules"
                    hide-details="auto"
                    v-model.number = "mounting.nModules"
                    @change="update"
                  ></v-text-field>
            </v-col>

          </v-row>  

          <v-row style="margin:0">
                  <div style="" >
                   <canvas  height="300" width= "2000"   ref="myCanvas"></canvas>
           </div>     

    
          </v-row>

        </v-container >
    


<!--     
    </div>
         -->
</template>

<script>



export default {
  name: "assembly-canvas",
  props: ["mounting", "index", "structures", "disabled"]
  ,
  mounted:function(){
      var c = this.$refs.myCanvas;
      var ctx = c.getContext("2d");   
      this.vueCanvas = ctx;
        this.update();
  },
   watch: {
    mounting: function (val) {
     // alert("changed");
      this.update();
    },
      
  },
  data() {
    return {
        orientationItems:[
                            {text:"Retrato", value:"portrait"},
                            {text:"Paisagem", value:"landscape"},
                            
        ],
        itemsMountingType :[
          {text:"Metálica Mini Rail", value:"metalica_mini_rail"},
            {text:"Metálica", value:"metalica"},
           {text:"Fibrocimento", value:"fibrocimento"},
           {text:"Cerâmica", value:"ceramica"},
                    

        ],
       escala:1,
       dist:5,
       wTotal:0,
       message: 'Configuracao',
      vueCanvas: null,
      rectWidth: 200 ,
      maxWidth:1000,
    } 
  },
  methods: {
    removeMe(){
     // alert(this.index);
        this.$emit("remove", this.index)
    },
    update(){

      //alert("update")
      // mountings:  {
      //     module: { height: 1960, width: 990 },
      //     type: "ceramica",
      //     structureId:"arnJNWFUOQausNSWrAuA",
      //     structure:{},
      //     nModules: 10,
      //     quantity: 1,
      //     orientation: "portrait",
      //     materiais: {},
      //     listaMateriais: [],
      //   };


       console.log("updated0")
      this.mounting.structure  = this.structures.find(element => element.id == this.mounting.structureId);
      console.log("udpate0")
      this.vueCanvas.clearRect(0, 0, 2000, 300);
        if(this.mounting.orientation=="portrait")
            this.wTotal = (this.dist + this.mounting.module.width/10) * this.mounting.nModules;
        else 
            this.wTotal = (this.dist +  this.mounting.module.height/10) * this.mounting.nModules;
      
        if(this.wTotal>this.maxWidth)
            this.escala = this.maxWidth/ this.wTotal;  
        else
            this.escala = 1;
        //this.escala =1;
        this.vueCanvas.font = "15px Arial";
            
            
        for(var a = 0; a<this.mounting.nModules ;a++){ 
        //  for(var a = 0; a<this.mounting.module.quantity ;a++){ 
                     
            if(this.mounting.orientation=="portrait"){
                this.drawmodule(this.mounting.module, a*(this.dist + this.mounting.module.width/10) ,30,this.escala);
                //this.vueCanvas.fillText(a+1,(a+0.5)* (this.dist + this.mounting.module.width/10)*this.escala , 20);
              
            }else{
                this.drawmodule(this.mounting.module, a*(this.dist + this.mounting.module.height/10) ,30,this.escala);
                //this.vueCanvas.fillText(a+1, (a+0.5)*(this.dist + this.mounting.module.height/10)*this.escala, 20);
             
            }
            
        }


        console.log("updated2")
          this.$emit("updated")

    },  
        
    // Close the sidebar with the close button
    drawmodule(module,x,y, escala) {
        this.vueCanvas.fillStyle = "#0c224d";
      //this..clearRect(0, 0, 300, 200);
      if(this.mounting.orientation=="portrait"){
        this.vueCanvas.beginPath();
        this.vueCanvas.fillRect(x * escala, y*escala, module.width*escala/10, module.height*escala/10);
        this.vueCanvas.strokeStyle = "#AAAAAA";
        this.vueCanvas.lineWidth = 0.5;
        
        this.vueCanvas.strokeRect(x*escala +( module.width/10) *escala*0.2 , y*escala,  (0.2* module.width/10)*escala , ( module.height*escala/10));
        this.vueCanvas.strokeRect(x*escala +( module.width/10) *escala*0.6 , y*escala,  (0.2* module.width/10)*escala , ( module.height*escala/10));

        this.vueCanvas.strokeRect(x*escala  ,y*escala + ( module.height/10) *escala*0.2 ,  ( module.width/10)*escala, 0.2*( module.height*escala/10)  );
        this.vueCanvas.strokeRect(x*escala  ,y*escala + ( module.height/10) *escala*0.6 ,  ( module.width/10)*escala, 0.2*( module.height*escala/10)  );
        //this.vueCanvas.strokeRect(x*escala + ( module.height/10) *escala*0.6 ,y*escala , 0.2*( module.height*escala/10),  ( module.width/10)*escala);
    
 
      }else{
        this.vueCanvas.beginPath();
        this.vueCanvas.fillRect(x * escala, y*escala , module.height*escala/10, module.width*escala/10);
        //this.vueCanvas.stroke();    
        this.vueCanvas.strokeStyle = "#AAAAAA";
        this.vueCanvas.lineWidth = 0.5;
        
        this.vueCanvas.strokeRect(x*escala ,y*escala + ( module.width/10) *escala*0.2, ( module.height*escala/10),  (0.2* module.width/10)*escala);
        this.vueCanvas.strokeRect(x*escala ,y*escala + ( module.width/10) *escala*0.6, ( module.height*escala/10),  (0.2* module.width/10)*escala);
      
        this.vueCanvas.strokeRect(x*escala + ( module.height/10) *escala*0.2 ,y*escala , 0.2*( module.height*escala/10),  ( module.width/10)*escala);
        this.vueCanvas.strokeRect(x*escala + ( module.height/10) *escala*0.6 ,y*escala , 0.2*( module.height*escala/10),  ( module.width/10)*escala);
    
    
      }
    },

    //alert( vnModules[ fileira].value);
    
    drawRect() {
      // draw rect
      //this.vueCanvas.beginPath();
      //this.vueCanvas.rect(20, 20, this.rectWidth, 100);
      //this.vueCanvas.stroke();      
    },
    addWidth() {
      this.rectWidth += 10
      this.drawRect()
    },
    subWidth() {
      this.rectWidth -= 10
      this.drawRect()      
    }
  }
};
</script>
